import http from '@/modules/Http'
import lscache from 'lscache'
import store from '../store'

export default {

  axios: http,

  setCache (key, object, expireIn) {
    lscache.set(store.state.user.id + '_' + key, JSON.stringify(object), expireIn)
  },

  getCache (key) {
    return JSON.parse(lscache.get(store.state.user.id + '_' + key))
  },

  async fetchWeekSchedules () {
    let schedules = this.getCache('weekSchedules')
    if (!schedules) {
      schedules = await this.fetch('m/students/me/schedules?scope=week')
      this.setCache('weekSchedules', schedules, 10)
    }
    return schedules
  },

  async fetchDaySchedules () {
    let schedules = this.getCache('daySchedules')
    if (!schedules) {
      schedules = await this.fetch('m/students/me/schedules?scope=day')
      this.setCache('daySchedules', schedules, 10)
    }
    return schedules
  },

  async fetchDayCourseInstances (courseInstanceIds) {
    let dayCourses = this.getCache('dayCourses')
    if (!dayCourses) {
      dayCourses = await this.fetchCourseInstances({
        studentId: 'me',
        courseInstanceId: courseInstanceIds,
        include: 'statistic'
      })
      this.setCache('dayCourses', dayCourses, 5)
    }
    return dayCourses
  },

  async fetchAllCourses () {
    let allCourses = this.getCache('allCourses')
    if (!allCourses) {
      allCourses = await this.fetchCourseInstances({studentId: 'me'})
      this.setCache('allCourses', allCourses, 10)
    }
    return allCourses
  },

  fetchCourseInstances (options) {
    let {studentId, courseInstanceId, include} = options
    let ids = courseInstanceId ? '/' + courseInstanceId.join() : ''
    let includeQuery = include ? `include=${include}` : ''
    let query = includeQuery ? `?${includeQuery}` : ''
    return this.fetch(`m/students/${studentId}/course_instances${ids}${query}`)
  },

  fetchHomework (studentId, courseInstanceId, status) {
    return this.fetch(`m/students/${studentId}/homeworks?course_instance=${courseInstanceId}&status=${status}`)
  },

  fetchScores (studentId, courseInstanceId) {
    return this.fetch(`m/students/${studentId}/scores?course_instance=${courseInstanceId}`)
  },

  fetchStatistics (studentId, courseInstanceId) {
    return this.fetch(`m/students/${studentId}/statistics?course_instance=${courseInstanceId}`)
  },

  async updateFeedback (studentId, date) {
    return (await http.post(`m/students/${studentId}/feedbacks`, {date})).data
  },

  async authCredential (email, password) {
    return (await http.post('m/auth/credential', { email, password })).data
  },

  authStatus () {
    return http.get('m/auth/status')
  },

  async link (wuid, relation, userId, token) {
    return (await http.post(`m/profile/${wuid}/wechat_links`, {relation_to_user: relation, user_id: userId, token})).data
  },

  async unlink (wuid, linkId) {
    return (await http.delete(`m/profile/${wuid}/wechat_links/${linkId}`)).data
  },

  async fetch (url) {
    return (await http.get(url)).data
  }

}



// WEBPACK FOOTER //
// ./src/modules/Backend.js